
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobenglurucabs() {



    const cardData =
    {
        keyword: 'Pune to Bengaluru Cabs ',
        heading: 'Platinum24 Cabs: Pune to Bengaluru Cabs',
        headingDescription: ' Platinum24 Cabs offers dependable Pune to Bengaluru cab services, ideal for business professionals, students, families, and leisure travelers. Whether you’re traveling for IT work in Electronic City, visiting landmarks like Lalbagh and Vidhana Soudha, or making a family trip to Mysuru and nearby destinations, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures comfort and safety throughout the journey. With punctual pickups, skilled chauffeurs, and transparent pricing, we provide a hassle-free intercity travel experience. From one-way drops to return packages, Platinum24 Cabs is your trusted partner for smooth and reliable Pune to Bengaluru travel.',

        top: 'Top Places to Visit in Bengaluru with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden, spread over 240 acres, is Bengaluru’s green treasure. It houses rare plants, ancient trees, and a stunning glasshouse modeled after London’s Crystal Palace. The annual flower shows draw huge crowds. Morning walkers and photographers love its peaceful ambiance. The garden also has a lake and iconic rock formation. Lalbagh is Bengaluru’s floral paradise."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park, in the city center, is a 300-acre green haven. Lined with trees, lawns, and walking paths, it offers a natural escape amidst the urban buzz. The park also houses statues, government buildings, and the State Central Library. Joggers and families enjoy it daily. Its colonial charm blends with modern landscaping. Cubbon Park is Bengaluru’s urban lung."
  },
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in 1878, is inspired by England’s Windsor Castle. Its Tudor-style architecture, wooden carvings, and grand halls showcase royal elegance. The palace houses paintings, furniture, and artifacts of the Wodeyar dynasty. Concerts and events are held here frequently. Tourists admire its sprawling lawns and regal aura. Bangalore Palace is Bengaluru’s royal heritage landmark."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha, an iconic government building, is the seat of Karnataka’s legislature. Built in Neo-Dravidian style, it features massive granite steps, domes, and pillars. Its inscription ‘Government Work is God’s Work’ is famous. Lit up in the evenings, it looks spectacular. Visitors admire it from outside as entry is restricted. Vidhana Soudha is Bengaluru’s architectural pride."
  },
  {
    "title": "ISKCON Temple",
    "description": "The ISKCON Temple in Bengaluru is one of the largest Krishna temples in the world. Built with modern architecture and traditional elements, it houses shrines of Radha-Krishna, Balaji, and Nitai-Gauranga. Devotees attend grand aartis and spiritual events daily. The temple complex includes cultural centers and eateries. Festivals like Janmashtami draw thousands. ISKCON Temple is Bengaluru’s divine spiritual hub."
  },
  {
    "title": "UB City",
    "description": "UB City is Bengaluru’s luxury mall and lifestyle destination. It houses global fashion brands, fine-dining restaurants, and rooftop lounges. The amphitheater hosts live events and cultural shows. Its architecture blends glass, steel, and modern design. Shoppers and food lovers find it irresistible. UB City is Bengaluru’s glamorous shopping hub."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park is a wildlife reserve just outside Bengaluru. It includes a zoo, safari rides, butterfly park, and rescue center. Visitors spot tigers, lions, elephants, and bears in natural enclosures. The park also conducts educational programs for children. Monsoon makes the forest trails more scenic. Bannerghatta is Bengaluru’s wildlife adventure spot."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bengaluru’s buzzing shopping lane. It is famous for clothes, accessories, footwear, and handicrafts at bargain prices. The narrow lanes are always crowded with locals and tourists. Street food and cafes add to the lively vibe. Shoppers find everything from trendy wear to ethnic outfits here. Commercial Street is Bengaluru’s colorful marketplace."
  },
  {
    "title": "Tipu Sultan’s Summer Palace",
    "description": "Tipu Sultan’s Summer Palace, built in Indo-Islamic style, is a historic gem in Bengaluru. Made of teakwood, it features intricately carved arches, balconies, and frescoes. It was once the summer retreat of Tipu Sultan, the Tiger of Mysore. Today, it houses exhibits of his reign and legacy. The palace reflects Mughal and Dravidian influences. It is Bengaluru’s heritage monument of pride."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills, about 60 km from Bengaluru, is a popular weekend getaway. The hilltop offers breathtaking sunrise views above the clouds. It has ancient temples, fort walls, and trekking trails. Cyclists and adventure seekers love its winding roads. Monsoon adds mist and greenery to the hills. Nandi Hills is Bengaluru’s scenic mountain retreat."
  }
],


            "services": [
    {
      "name": "Pune to Bengaluru Cab",
      "description": "Travel in comfort with our Pune to Bengaluru Cab service, ideal for long-distance journeys between two major cities. Our professional drivers, clean vehicles, and on-time service ensure a smooth, reliable, and safe travel experience."
    },
    {
      "name": "Pune to Bangalore Taxi Service",
      "description": "Our Pune to Bangalore Taxi Service offers dependable intercity travel with a focus on punctuality and safety. Perfect for business travelers or families, this service includes multiple vehicle options and trained chauffeurs for a hassle-free journey."
    },
    {
      "name": "Book Pune to Bengaluru Cab",
      "description": "Book Pune to Bengaluru Cab online quickly with our easy-to-use booking platform. Enjoy flexible scheduling, instant confirmation, and transparent fares — ideal for travelers seeking convenience and efficiency."
    },
    {
      "name": "Pune to Bengaluru Car Hire",
      "description": "Choose from a wide range of self-drive and chauffeur-driven options with our Pune to Bengaluru Car Hire service. Whether for business, leisure, or relocation, we offer clean, well-maintained cars suited to your needs."
    },
    {
      "name": "Pune to Bengaluru Outstation Cabs",
      "description": "Opt for our Pune to Bengaluru Outstation Cabs for a worry-free intercity ride. Equipped for long journeys, our vehicles offer ample space, comfortable seating, and experienced drivers familiar with highway routes."
    },
    {
      "name": "Pune to Bangalore One Way Cab",
      "description": "Save more with our Pune to Bangalore One Way Cab service. Designed for travelers who don’t need a return trip, this one-way option is budget-friendly and includes doorstep pickup and drop-off services."
    },
    {
      "name": "Pune to Bengaluru Luxury Taxi",
      "description": "Travel in style with our Pune to Bengaluru Luxury Taxi service. Featuring premium cars, professional chauffeurs, and top-class comfort, this option is ideal for executives and travelers who prefer high-end travel experiences."
    },
    {
      "name": "Affordable Pune to Bengaluru Cabs",
      "description": "Enjoy budget-friendly travel with our Affordable Pune to Bengaluru Cabs. With competitive pricing, reliable service, and comfortable vehicles, this option is perfect for frequent or long-distance travelers seeking value."
    },
    {
      "name": "Cab from Pune to Bengaluru",
      "description": "Looking for a Cab from Pune to Bengaluru? We provide round-the-clock cab services for travelers needing a comfortable, safe, and reliable journey between these two major cities in India."
    },
    {
      "name": "Pune to Bangalore Taxi Booking Online",
      "description": "Make your travel plans easily with our Pune to Bangalore Taxi Booking Online service. Choose your vehicle, check fare estimates, and confirm your booking in just a few steps. Quick, secure, and available 24/7."
    },
    {
      "name": "Pune to Bengaluru Car Rental",
      "description": "Our Pune to Bengaluru Car Rental service offers flexible rental plans, ranging from a few hours to multiple days. Whether for business or pleasure, choose from sedans, SUVs, or premium vehicles tailored to your travel style."
    }
  ],
  "tableData": [
    ["Pune to Bengaluru Cab", "Pune to Bangalore Taxi Service"],
    ["Book Pune to Bengaluru Cab", "Pune to Bengaluru Car Hire"],
    ["Pune to Bengaluru Outstation Cabs", "Pune to Bangalore One Way Cab"],
    ["Pune to Bengaluru Luxury Taxi", "Affordable Pune to Bengaluru Cabs"],
    ["Cab from Pune to Bengaluru", "Pune to Bangalore Taxi Booking Online"],
    ["Pune to Bengaluru Car Rental", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Bengaluru Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers comfortable and dependable cab services for your Pune to Bengaluru journey, ensuring a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Variety of Vehicles to Suit Your Group Size",
    "WhyChoosedescription": "Choose from sedans, SUVs, and tempo travellers, all well-maintained and perfect for long-distance travel between Pune and Bengaluru."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Your Safety",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and comfortable ride on your Pune to Bengaluru trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Bengaluru to ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Transparent fares including fuel, tolls, and driver allowances make your Pune to Bengaluru cab ride hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short or Long-Term Travel",
    "WhyChoosedescription": "Choose hourly, daily, or customized rental plans based on your Pune to Bengaluru travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Bengaluru cab quickly and securely through our website or app with real-time confirmation."
  }
]


















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Bengaluru cab services?',
        answer: 'Yes, Platinum24 Cabs offers comfortable and reliable cab services from Pune to Bengaluru with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Bengaluru?',
        answer: 'You can easily book your cab via our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for Pune to Bengaluru travel?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your preferences and budget.',
    },
    {
        question: 'Is one-way cab service available from Pune to Bengaluru?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Bengaluru routes.',
    },
    {
        question: 'Are the drivers experienced for long-distance trips like Pune to Bengaluru?',
        answer: 'Absolutely, our drivers are licensed, experienced, and knowledgeable about the Pune to Bengaluru route.',
    },
    {
        question: 'Can I customize my pickup and drop-off locations in Pune and Bengaluru?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Pune and Bengaluru.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Bengaluru cabs?',
        answer: 'All vehicles are sanitized regularly, and drivers follow strict safety measures to ensure a safe journey.',
    },
    {
        question: 'Is Pune to Bengaluru cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Bengaluru cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Bengaluru cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and credit/debit cards for easy payment.',
    },
    {
        question: 'Are there customizable packages for Pune to Bengaluru cab travel?',
        answer: 'Yes, we offer flexible packages that can be tailored to your specific travel requirements.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Arjun Rao',
        feedback: 'The Pune to Bengaluru cab service by Platinum24 Cabs was punctual and comfortable. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Nair',
        feedback: 'Excellent service with professional drivers. My Pune to Bengaluru trip was hassle-free and smooth.',
        rating: 5,
    },
];








































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToBengaluruCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bengaluru Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-bengaluru-cab.jpg",
  "description": "Book Pune to Bengaluru cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and luxury taxis for one-way and round trips. Reliable, comfortable, and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-bengaluru-cab-service"
  }
};




    return (
        <div>


<Helmet>
  <title>Pune to Bengaluru Cab Service | Affordable & Luxury Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Bengaluru cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and luxury taxis for one-way and round trips. Reliable, comfortable, and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Bengaluru Cab, Pune to Bangalore Taxi Service, Book Pune to Bengaluru Cab, Pune to Bengaluru Car Hire, Pune to Bengaluru Outstation Cabs, Pune to Bangalore One Way Cab, Pune to Bengaluru Luxury Taxi, Affordable Pune to Bengaluru Cabs, Cab from Pune to Bengaluru, Pune to Bangalore Taxi Booking Online, Pune to Bengaluru Car Rental"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToBengaluruCabSchema)}
  </script>
</Helmet>




            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/102.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobenglurucabs;